// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vFKX","index":"styles_index__f79cj"};